import {useEffect,useState} from "react";
import "./ScrollProgress.css";


function ScrollProgress(){


const [progress,setProgress]=useState(0);



useEffect(()=>{


const updateScroll=()=>{


const scrollTop=
window.scrollY;


const height=
document.documentElement.scrollHeight -
window.innerHeight;


const percent=
(scrollTop/height)*100;


setProgress(percent);


};


window.addEventListener(
"scroll",
updateScroll
);


return()=>{

window.removeEventListener(
"scroll",
updateScroll
);

};


},[]);



return(

<div

className="scroll-progress"

style={{
width:`${progress}%`
}}

/>

)

}


export default ScrollProgress;